import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'

// Temporary until https://github.com/gtournie/redux-form-validators/pull/9 gets released
import { required, email } from 'redux-form-validators/lib/'
import { valueRequired } from '../../util/validators'
import { Submitting } from '../common/Submitting'
import { TextField, SelectField, Textarea, RadioGroup } from '@foodsby/nutrient'

const ContactUsForm = ({
  handleSubmit,
  reasons,
  selectedReason,
  submitting
}) => {
  return (
    <form className="contact-us-form" onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-4">
          <Field
            id="user.name"
            name="user.name"
            component={TextField}
            type="text"
            label="Name *"
            maxLength="50"
            validate={[required({ msg: `Name is required` })]}
          />
        </div>
        <div className="col-xs-12 col-sm-6 col-md-4">
          <Field
            id="user.email"
            name="user.email"
            component={TextField}
            type="email"
            label="Email *"
            maxLength="254"
            validate={[required({ msg: `Email is required` }), email()]}
          />
        </div>
        <div className="col-xs-12 col-sm-12 col-md-4">
          <Field
            id="order.location"
            name="order.location"
            component={TextField}
            type="text"
            label="Building Location"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-4">
          <Field
            id="order.store"
            name="order.store"
            component={TextField}
            type="text"
            label="Restaurant"
          />
        </div>
        <div className="col-xs-12 col-sm-6 col-md-4">
          <Field
            id="order.id"
            name="order.id"
            component={TextField}
            type="text"
            label="Order Number"
          />
        </div>
        <div className="col-xs-12 col-sm-6 col-md-4">
          <Field
            id="order.orderStatus"
            name="order.orderStatus"
            component={TextField}
            type="text"
            label="Order Status"
          />
        </div>
      </div>
      <div className="row pb-1">
        <div className="col-xs-12 col-sm-6 col-md-4">
          <Field
            id="reasonType"
            name="reasonType"
            component={SelectField}
            label="Reason Type *"
            validate={[required({ msg: `Reason Type is required` })]}
          >
            <option key={0} value="" />
            {reasons.map(reason => {
              return (
                <option key={reason.id} value={reason.id}>
                  {reason.label}
                </option>
              )
            })}
          </Field>
        </div>
      </div>
      {selectedReason && (
        <div className="row">
          <div className="col-xs-12">
            <Field
              name="reasonOption"
              component={RadioGroup}
              options={selectedReason ? selectedReason.options : []}
              valKey="id"
              labelKey="label"
              validate={valueRequired}
              normalize={value => Number(value)}
            />
          </div>
        </div>
      )}
      <Field
        id="comments"
        name="comments"
        component={Textarea}
        type="textarea"
        label="description"
      />
      <div className="row reverse pt-1">
        {submitting ? <Submitting /> : <button type="submit">Submit</button>}
      </div>
    </form>
  )
}

ContactUsForm.propTypes = {
  reasons: PropTypes.array.isRequired,
  selectedReason: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool
}

export default ContactUsForm
